@if (model$ | async; as model) {
  <div class="container-left" id="landing-summary-left">
    <div class="icon">
      <span class="icon-learniz-bookshelf"></span>
    </div>
    <h2 [innerHTML]="'learniz.landing-page.chapter-title' | wording"></h2>
  </div>
  <div class="container-right" id="landing-summary-right">
    <div class="summary">
      @if (model.chapters.length > 1) {
        <mat-accordion [multi]="false">
          @for (chapter of model.chapters; track chapter; let i = $index) {
            <mat-expansion-panel [ngClass]="!chapter.description ? 'mat-hide-toggle' : ''">
              <mat-expansion-panel-header expandedHeight="auto" collapsedHeight="auto">
                <mat-panel-title class="summary-chapter-title">
                  <span class="chapter-number">{{ i + 1 | numberTitle }}</span>
                  <div class="chapter-title">
                    <span [innerHTML]="chapter.title"></span>
                    <span class="summary-chapter-link">
                      <a [routerLink]="getLinkChapter(i)">{{ 'learniz.summary.link' | wording }}</a>
                      <span class="icon-learniz-chevrons-right"></span>
                    </span>
                  </div>
                </mat-panel-title>
              </mat-expansion-panel-header>
              @if (chapter.description) {
                <div class="summary-chapter-description" [innerHTML]="chapter.description | safeHtml"></div>
              }
            </mat-expansion-panel>
          }
        </mat-accordion>
      } @else {
        @if (model.chapters[0]?.slides) {
          <mat-accordion [multi]="false">
            @for (slide of model.chapters[0].slides; track slide; let i = $index) {
              <mat-expansion-panel class="mat-hide-toggle">
                <mat-expansion-panel-header expandedHeight="auto" collapsedHeight="auto">
                  <mat-panel-title class="summary-chapter-title">
                    <span class="chapter-number">{{ i + 1 | numberTitle }}</span>
                    <div class="chapter-title">
                      <span>{{ slide.title }}</span>
                      <span class="summary-chapter-link">
                        <a [routerLink]="getLinkSlide(i)">{{ 'learniz.summary.link' | wording }}</a>
                        <span class="icon-learniz-chevrons-right"></span>
                      </span>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
              </mat-expansion-panel>
            }
          </mat-accordion>
        }
      }
    </div>
  </div>
}
